
	import { defineComponent, PropType } from 'vue';
	import JsonViewItem from './JsonViewItem.vue';
	import { ColorMode, JsonData, JsonDataType, SelectedJsonData } from '@/types';

	export default /*#__PURE__*/defineComponent({
		name      : 'json-view',
		props     : {
			data       : {
				required: true
			},
			rootKey    : {
				type    : String,
				required: false,
				default : 'root'
			},
			maxDepth   : {
				type    : Number,
				required: false,
				default : 1
			},
			colorScheme: {
				type    : String as PropType<ColorMode>,
				required: false,
				default : ColorMode.LIGHT
			}
		},
		components: { JsonViewItem },
		emits     : [ 'update:selected' ],
		methods   : {
			build(key: string, val: any, depth: number, path: string, includeKey: boolean): JsonData {
				if (this.isObject(val)) {
					// Build Object
					let children = [];
					for (let [ childKey, childValue ] of Object.entries(val)) {
						children.push(
							this.build(
								childKey,
								childValue,
								depth + 1,
								includeKey ? `${path}${key}.` : `${path}`,
								true
							)
						);
					}
					return {
						key     : key,
						type    : JsonDataType.OBJECT,
						depth   : depth,
						path    : path,
						length  : children.length,
						children: children
					};
				} else if (this.isArray(val)) {
					// Build Array
					let children = [];
					for (let i = 0; i < val.length; i++) {
						children.push(
							this.build(
								i.toString(),
								val[ i ],
								depth + 1,
								includeKey ? `${path}${key}[${i}].` : `${path}`,
								false
							)
						);
					}
					return {
						key     : key,
						type    : JsonDataType.ARRAY,
						depth   : depth,
						path    : path,
						length  : children.length,
						children: children
					};
				} else {
					// Build Value
					return {
						key  : key,
						type : JsonDataType.VALUE,
						path : includeKey ? path + key : path.slice(0, -1),
						depth: depth,
						value: val
					};
				}
			},
			isObject: (val: any) => typeof val === 'object' && val !== null && !Array.isArray(val),
			isArray : (val: any) => Array.isArray(val),
			itemSelected(data: SelectedJsonData): void {
				this.$emit('update:selected', data);
			}
		},
		computed  : {
			parsed(): JsonData {
				if (typeof this.data === 'object') {
					return this.build(this.rootKey, { ...this.data }, 0, '', true);
				}
				return {
					key  : this.rootKey,
					type : JsonDataType.VALUE,
					path : '',
					depth: 0,
					value: this.data
				};
			},
			hasSelectedListener(): boolean {
				return !!this.$attrs.onSelected;
			}
		}
	});
